import React, { useState, useEffect, useRef } from "react";
import AuctionCardComponent from "../../Components/card/AuctionCard";
import AuctionResults from "./AuctionResults";
import { getAuncitonsWithPagination } from "../../services/aunction";
import useFetch from "../../hooks/useFetch";
import { auctionData } from "../../Components/BankAunctionData/aunction";
import { formatNumberUtil } from "../../Utils/localStorageUtils";
import MultiSelectComponent from "../../Components/MultiSelect/MultiSelect";

const BankAuctionPage2 = () => {
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(""); // live/closed
  const [sort, setSort] = useState(""); // highToLow/lowToHigh
  const [propertyType, setPropertyType] = useState("all"); // residential, commercial, agriculture, industrial
  const loaderRef = useRef(null);


  // Use fetched data if available, otherwise fallback to local data
  let auctions = auctionData;

  // Apply filtering
  if (filter === "live") {
    auctions = auctions.filter(auction => auction.auctionCloseDate !== "NA");
  } else if (filter === "closed") {
    auctions = auctions.filter(auction => auction.auctionCloseDate === "NA");
  }

   // Apply property type filter
   if (propertyType !== "all") {
    auctions = auctions.filter(auction => auction.propertyType.toLowerCase() === propertyType);
  }

  // Apply sorting
  if (sort === "highToLow") {
    auctions = [...auctions].sort((a, b) => b.reservePrice - a.reservePrice);
  } else if (sort === "lowToHigh") {
    auctions = [...auctions].sort((a, b) => a.reservePrice - b.reservePrice);
  }

  return (
    <div className="py-[200px] max-w-5xl mx-auto">

    {/* <MultiSelectComponent/> */}

      {/* Filter and Sort Select Options */}
      <AuctionResults
        totalResults={auctions.length}
        onFilterChange={setFilter}
        onSortChange={setSort}
        onPropertyTypeChange={setPropertyType}
      />

      {/* Display Auctions or No Results Message */}
      {auctions.length > 0 ? (
        auctions.map((auction, index) => (
          <div key={auction.propertyId || index} className="py-2">
            <AuctionCardComponent
              bank={auction.bankName}
              location={`${auction.city}, ${auction.state}`}
              refNo={auction.propertyId}
              description={auction.summaryDescription}
              closingDate={auction.auctionCloseDate}
              emd={auction.emd}
              estimatedCost={auction.reservePrice}
              // price={`₹${(auction.reservePrice / 100000).toFixed(2)} Lacs`}
              price={`₹${formatNumberUtil(auction.reservePrice)}`}
              daysLeft={"NA"}
              pdfUrl={auction.pdfUrl}
              propertyType={auction.propertyType} // Now passing propertyType
            />
          </div>
        ))
      ) : (
        <div className="text-center py-10">
          <p className="text-xl font-semibold text-gray-700">
            🚫 No auctions found
          </p>
          <p className="text-gray-500">Try adjusting the filters or check back later.</p>
        </div>
      )}
    </div>
  );
};

export default BankAuctionPage2;
